import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchDepartment, fetchActionsByDepartment } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function DepartmentActionListPage() {
  const { businessDomainId, businessUnitId, departmentId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const basePath = `/strategy/${businessDomainId}/business-units/${businessUnitId}/departments/${departmentId}`;

  const [departmentName, setDepartmentName] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const [d, actions] = await Promise.all([
        fetchDepartment(departmentId),
        fetchActionsByDepartment(departmentId),
      ]);
      setDepartmentName(d.departmentName || "");
      const mapped = (actions || []).map((a) => ({
        id: a.actionId,
        actionName: a.actionName || "",
        actionDescription: a.actionDescription || "",
        raw: a,
      }));
      setRows(mapped);
    } catch (e) { notify.apiError(e); }
    finally { setLoading(false); }
  }, [departmentId]);

  useEffect(() => { loadData(); }, [loadData]);

  const columns = [
    { field: "actionName", headerName: t("department.action.name"), flex: 1, minWidth: 200 },
    { field: "actionDescription", headerName: t("common.description"), flex: 2, minWidth: 200 },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">
          {departmentName}：{t("department.actions")}
        </Typography>
        <Button variant="contained" startIcon={<AddIcon />}
          onClick={() => navigate(`${basePath}/actions/add`)}>
          {t("common.add")}
        </Button>
      </Box>

      <Box sx={{ height: 400 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          pageSizeOptions={[100]}
          initialState={{ pagination: { paginationModel: { pageSize: 100 } } }}
          onRowClick={(params) => navigate(`${basePath}/actions/${params.row.id}`)}
          sx={{ cursor: "pointer" }}
        />
      </Box>

      <Box sx={{ mt: 2 }}>
        <Button variant="outlined" onClick={() => navigate(basePath)}>{t("common.back")}</Button>
      </Box>

    </Box>
  );
}
